import {Divider, message} from 'antd'
import {auth_login_Api} from 'apis'
import {NullAsDefault} from "views/Shared";
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {useDispatch} from 'react-redux'
import {loginSuccess} from 'redux/actions'
import {renderIfElse} from '../Shared'
import GoogleLoginBtn from './GoogleLoginBtn/index'
import './Login.css'
import LoginForm from './LoginForm'
import {useToggle} from "react-use";
import {FcGoogle} from "react-icons/fc";

const LoginOrSkip = ({ onSuccess = NullAsDefault }) => {
    const t = useTranslate()
    const dispatch = useDispatch()
    const [isToggle, toggle] = useToggle()

    const { isLoading, handleAsyncAction } = useAsyncAction({
        apiInfo: auth_login_Api,
        onSuccess: (...args) => {
            dispatch(loginSuccess(_.get(args, '1.response.data')))
            onSuccess()
        },
        onError: (...args) => message.error(_.get(args, '1.message')),
    })

    return (
        <div className="flex flex-col">
            <div className="flex flex-col flex-center font-bold text-lg text-color-000 uppercase tracking-widest">
                {t('login on')}
                <span className="text-base text-primary leading-snug tracking-widest">{'Kristo Network'}</span>
            </div>
            <div className="px-3 py-10 space-y-6">
                {renderIfElse(
                    isToggle,
                    <React.Fragment>
                        <div className="text-center text-sm text-color-000 font-medium mb-2 italic">
                            {t('with account')} Kristo Network
                        </div>
                        <LoginForm />
                    </React.Fragment>,
                    <React.Fragment>
                        <section className="mx-0 md:mx-8">
                            <GoogleLoginBtn
                                onSuccess={handleAsyncAction}
                                renderButton={
                                    <div className="flex bg-primary-50 hover:bg-primary-100 text-primary hover:shadow-items rounded-lg cursor-pointer">
                                        <div className="flex flex-center p-2 border-r border-white">
                                            <FcGoogle size={18}/>
                                        </div>
                                        <div className="flex flex-1 flex-center px-4 font-semibold tracking-wide">
                                            {t('Sign in with Google')}
                                        </div>
                                    </div>
                                }
                            />
                        </section>
                        <section className="mx-0 md:mx-8">
                            <div
                                onClick={toggle}
                                className="text-center font-medium text-sm text-color-300 hover:text-color-100 italic cursor-pointer relative">
                                {t('Sign in with account')}{' Kristo'}
                            </div>
                        </section>
                        <Divider style={{marginBottom: 0, color: 'var(--text-color-500)', fontSize: '0.75rem'}} className="lowercase">
                            {t('or')}
                        </Divider>
                        <section className="mx-0 md:mx-8">
                            <div
                                onClick={() => { onSuccess()}}
                                style={{ height: 32 }}
                                className="flex flex-center bg-blue-100 hover:bg-blue-100 hover:shadow-items rounded-md cursor-pointer">
                                <span className="font-medium text-sm text-blue-600 tracking-wider">
                                    {t('skip login')}
                                </span>
                            </div>
                        </section>
                    </React.Fragment>
                )}
            </div>
        </div>
    )
}
export default LoginOrSkip
